const Routes = [
  {
    path: '/daily-sales',
    name: 'DailySales',
    component: () => import('@/app/daily_sales/TheDailySales'),
    redirect: '/daily-sales/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/',
        name: 'dailySalesIndex',
        component: () => import('@/app/daily_sales/views/Index')
      },
      {
        path: ':retailId?date=:date',
        name: 'dailySalesDetail',
        component: () => import('@/app/daily_sales/views/Detail'),
        props: true
      }
    ]
  }
]

export default Routes



// WEBPACK FOOTER //
// ./src/app/daily_sales/Routes.js